import { render, staticRenderFns } from "./bubble.vue?vue&type=template&id=21521195&scoped=true&"
import script from "./bubble.vue?vue&type=script&lang=js&"
export * from "./bubble.vue?vue&type=script&lang=js&"
import style0 from "./bubble.vue?vue&type=style&index=0&id=21521195&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21521195",
  null
  
)

export default component.exports